import { moduleDefectApi } from '@/apis/module.defect.api';
import { wrapAsyncWithCache, shallowCloneJsonLike } from '@/utils/asyncResultCache';

export function defectDetailCacheKey(defectId) {
  const n = Number(defectId);
  return Number.isFinite(n) && n > 0 ? n : defectId;
}

/**
 * GET /moduleDefects/{id} 단일 캐시(지도 팝업 마커 + DefectOverlayPopupContent 공용).
 * 동일 클릭에서 네트워크 요청이 중복되지 않도록 한다.
 */
const fetchModuleDefectDetail = wrapAsyncWithCache(
  (defectId) => moduleDefectApi.getDefectById(defectId),
  {
    cacheKey: (defectId) => {
      if (!defectId) return null;
      return String(defectDetailCacheKey(defectId));
    },
    maxEntries: 512,
    cloneResult: shallowCloneJsonLike
  }
);

export async function getModuleDefectDetailCached(defectId) {
  if (!defectId) return null;
  return fetchModuleDefectDetail(defectId);
}

export function setModuleDefectDetailCache(defectId, detail) {
  if (!defectId) return;
  fetchModuleDefectDetail.setCachedResult(String(defectDetailCacheKey(defectId)), detail);
}

export function invalidateModuleDefectDetailCache(defectId) {
  if (!defectId) return;
  fetchModuleDefectDetail.invalidateCache(String(defectDetailCacheKey(defectId)));
}
